var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-layout',{staticClass:"page-error-500",attrs:{"img":require('@/assets/img/error/500.png'),"desc":"服务器正在升级"}})}
var staticRenderFns = []

export { render, staticRenderFns }